<template>
  <div class="fullscreen" ref="container">
    <div class="secret-name-container">
      <div class="unlock-header-text-container" id="secret-name-container">
        <div class="secret-name">{{ actionName }}</div>
        <div class="unlocked-text">discovered</div>
      </div>
      <div class="levelup-header-text-container" id="levelup-name-container">
        <div class="secret-name">{{ levelupHeaderText }}</div>
        <div class="unlocked-text">{{ levelupSubheaderText }}</div>
      </div>
    </div>
    <div class=""></div>
    <div class="animation-container">
      <div id="unlock-anim"></div>
      <div id="level-complete-anim"></div>
    </div>
    <div class="numbers">
      <div
        v-for="i in Math.max(0, step - 1)"
        class="empty-number-done"
        :key="`before-${i}`"
      ></div>
      <div class="empty-number" id="unlocked-number"></div>
      <div
        v-for="i in Math.max(0, maxSteps - step)"
        class="empty-number"
        :key="`after-${i}`"
      ></div>
    </div>
    <div class="bottom-section" id="bottom-section">
      <!--<div class="count-remaining">{{ maxSteps - step }} secrets remaining</div>-->
      <a @click="done" class="done-button throb">
        {{ buttonText }}
      </a>
    </div>
  </div>
</template>

<script>
import lottie from 'lottie-web'
import gsap from 'gsap'
import * as unlockAnimData from '@/assets/unlock-anim-background-only.json'
import * as levelCompleteAnimData from '@/assets/congrats/69021-success-interaction.json'

export default {
  name: 'Unlock3',
  data() {
    return {
      maxSteps: 6,
      levelCompleteAnim: undefined,
      discoveredDone: false,
      buttonText: 'Continue',
      levelupHeaderText: 'Level complete',
      levelupSubheaderText: 'Well done!',
    }
  },
  mounted() {
    if (this.noMoreLevels) {
      this.levelupHeaderText = 'All levels complete'
      this.levelupSubheaderText = 'What a ride!'
    }

    const unlockAnim = lottie.loadAnimation({
      container: document.getElementById('unlock-anim'),
      animationData: unlockAnimData.default,
      renderer: 'svg',
      autoplay: false,
      loop: false,
    })

    unlockAnim.goToAndPlay(0)

    const levelCompleteAnim = lottie.loadAnimation({
      container: document.getElementById('level-complete-anim'),
      animationData: levelCompleteAnimData.default,
      renderer: 'svg',
      autoplay: false,
      loop: false,
    })

    this.levelCompleteAnim = levelCompleteAnim

    const tl = gsap.timeline({ repeat: 0 })

    tl.from(
      '#secret-name-container',
      {
        opacity: 0,
        y: -15,
        duration: 0.75,
      },
      1.2
    )

    tl.fromTo(
      '#unlocked-number',
      {
        backgroundColor: 'transparent',
        scale: 2,
      },
      {
        scale: 1,
        backgroundColor: '#cdf4dd',
        duration: 0.75,
        immediateRender: false,
      },
      1.2
    )

    tl.addLabel('unlockAnimFinished')

    tl.from(
      '#bottom-section',
      {
        opacity: 0,
        y: 15,
        duration: 0.75,
      },
      1.4
    )
  },
  computed: {
    step() {
      return this.$store.getters.unlockedActionsCount
    },
    /*actionName() {
      return this.$store.getters.lastUnlockedActionName
    },*/
    /*actionKeyBase() {
      return this.$store.getters.lastUnlockedAction.split('_')[0]
    },*/
    actionName() {
      return this.$store.getters.actions[this.$store.getters.lastUnlockedAction]
    },
    /*backgroundColour() {
      if (this.$store.getters.stage == 'green') {
        return 'rgb(0, 20, 23, 0.8)'
      } else if (this.$store.getters.stage == 'blue') {
        return 'rgb(7, 14, 41, 0.8)'
      } else {
        return 'rgb(51, 11, 15, 0.8)'
      }
    },
    backgroundColourStyle() {
      return {
        backgroundColor: this.backgroundColour,
      }
    },*/
    levelComplete() {
      return this.step >= this.maxSteps
    },
    noMoreLevels() {
      return this.$store.getters.level >= 1
    },
  },
  methods: {
    done() {
      /*if (this.step == this.maxSteps) {
        this.$store.commit('SET_SHOW_UNLOCK_DIALOG', false)
        this.$store.commit('SET_SHOW_LEVEL_START_SCREEN', true)
        this.$store.commit('SET_BLOCK_CLICKS', [])
        this.$store.commit('SET_LEVEL', this.$store.getters.level + 1)
        setTimeout(() => {
          this.$store.dispatch('play_level_start_anim')
        }, 500)
      } else {
        this.$store.commit('SET_SHOW_UNLOCK_DIALOG', false)
        this.$store.commit('SET_BLOCK_CLICKS', [])
      }*/
      if (this.levelComplete && !this.discoveredDone) {
        this.discoveredDone = true
        this.levelCompleteAnimation()
      } else if (
        this.levelComplete &&
        this.discoveredDone &&
        this.noMoreLevels
      ) {
        this.$store.commit('SET_SHOW_UNLOCK_DIALOG', false)
        this.$store.commit('SET_BLOCK_CLICKS', [])
        this.$store.commit('SET_SHOW_INTRO_SCREEN', true)
      } else if (this.levelComplete && this.discoveredDone) {
        this.$store.commit('SET_SHOW_UNLOCK_DIALOG', false)
        this.$store.commit('SET_SHOW_LEVEL_START_SCREEN', true)
        this.$store.commit('SET_BLOCK_CLICKS', [])
        this.$store.commit('SET_LEVEL', this.$store.getters.level + 1)
        setTimeout(() => {
          this.$store.dispatch('play_level_start_anim')
        }, 500)
      } else {
        this.$store.commit('SET_SHOW_UNLOCK_DIALOG', false)
        this.$store.commit('SET_BLOCK_CLICKS', [])
      }
    },
    levelCompleteAnimation() {
      const tl = gsap.timeline({ repeat: 0 })

      tl.to(
        '#secret-name-container',
        {
          opacity: 0,
          duration: 0.5,
        },
        'startAnim'
      )

      tl.to(
        '#bottom-section',
        {
          opacity: 0,
          duration: 0.5,
          onComplete: () => {
            if (!this.noMoreLevels) {
              this.buttonText = 'Next level'
            } else {
              this.buttonText = "It's been fun"
            }
          },
        },
        'startAnim'
      )

      tl.fromTo(
        '#levelup-name-container',
        {
          opacity: 0,
          y: -15,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.75,
        }
      )

      tl.to(
        '#unlock-anim',
        {
          scale: 0,
          duration: 0.5,
          onComplete: () => {
            this.levelCompleteAnim.goToAndPlay(0)
          },
        },
        'startAnim'
      )

      tl.from(
        '#bottom-section',
        {
          opacity: 0,
          y: 15,
          duration: 0.75,
        },
        'startAnim+=1.23'
      )
    },
  },
}
</script>

<style scoped>
.fullscreen {
  position: absolute;
  font-family: 'Montserrat', sans-serif;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /*background-color: rgba(0, 0, 0, 0.7);*/
  background-color: rgba(3, 28, 33, 0.8);
  color: #cdf4dd;
}

.animation-container {
  position: relative;
  width: 60vw;
  max-width: 15rem;
  height: 60vw;
  max-height: 15rem;
  margin-bottom: 1rem;
}

#unlock-anim {
  width: 100%;
  height: 100%;
}

#level-complete-anim {
  /*position: absolute;
  top: 0px;*/
  position: absolute;
  top: 0px;
  width: 300%;
  height: 300%;
  transform: translate(-33%, -33%);
  /*opacity: 0;*/
}

/*#unlock-anim {
  width: 60%;
  max-width: 15rem;
  margin-bottom: 1rem;
}*/

.done-button {
  max-width: 10em;
  width: 90%;
  display: inline-block;
  padding: 1em;
  text-align: center;
  border: 1px solid #cdf4dd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease;
}

.bottom-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.count-remaining {
  margin-bottom: 1rem;
}

@media (hover: hover) {
  .done-button:hover {
    background-color: rgba(204, 244, 221, 0.1);
  }
}

.secret-name-container {
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /*padding: 0rem 0.5rem 0rem 0.5rem;*/
  width: calc(100% - 2rem);
  max-width: 35rem;
  position: relative;
}

.secret-name {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  text-align: center;
}

.unlocked-text {
  text-transform: uppercase;
  font-size: 1.25rem;
  text-align: center;
  font-weight: 100;
}

.levelup-header-text-container {
  position: absolute;
  opacity: 0;
}

.steps {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1em;
  text-align: center;
  margin-bottom: 2rem;
}

/*.steps * {
  display: block;
}*/

.steps .numbers > * + * {
  margin-left: 0.25em;
}
.steps .numbers {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.5em;
}

.steps .number {
  font-size: 1.5em;
  font-weight: bold;
  background-color: #cdf4dd;
  color: #003745;
  border: 1px solid #cdf4dd;
  border-radius: 50%;
  width: 1.75em;
  height: 1.75em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.numbers {
  font-size: 0.5rem;
  margin-bottom: 2rem;
}

.numbers > * + * {
  margin-left: 0.75em;
}

.empty-number {
  display: inline-block;
  font-size: 1.5em;
  border-radius: 50%;
  width: 1em;
  height: 1em;
  border: 1px solid #cdf4dd;
  background-color: transparent;
}

.empty-number-done {
  display: inline-block;
  font-size: 1.5em;
  border-radius: 50%;
  width: 1em;
  height: 1em;
  border: 1px solid #cdf4dd;
  background-color: #cdf4dd;
}

.done-button.throb {
  animation-name: button-throb-animation;
  animation-duration: 0.75s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transform-origin: center;
}

@keyframes button-throb-animation {
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(224, 168, 0, 0.3);
  }
}
</style>
